import classnames from 'classnames';

import { ReactComponent as ChevronLeft } from '~/assets/images/iconsLibrary/chevron-left.svg';

import styles from './ChevronTurningPlainIcon.module.scss';

interface IChevronTurningPlainIcon {
  rotated: boolean;
  className?: string;
}

export default function ChevronTurningPlainIcon({
  rotated,
  className,
}: IChevronTurningPlainIcon): JSX.Element {
  return (
    <ChevronLeft
      className={classnames(
        styles.chevron,
        rotated && styles.rotated,
        className,
      )}
    />
  );
}
